var _rect, _path, _mask, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovieIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3751 41.8942C40.3221 42.8979 39.8659 43.7213 38.8679 44.2567C36.6407 45.4512 34.4143 46.6475 32.1799 47.8306C31.1871 48.3561 30.1587 48.3722 29.1639 47.8467C28.162 47.3176 27.6367 46.5058 27.6343 45.4343C27.6295 43.0685 27.6222 40.7027 27.6262 38.3372C27.6282 37.1325 28.2322 36.2489 29.4237 35.7395C30.4149 35.3157 31.3827 35.4401 32.316 35.9414C34.4629 37.094 36.6146 38.2389 38.7667 39.3835C39.8092 39.9376 40.3353 40.7643 40.3751 41.8942Z",
    fill: "#D3AA29"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1920_2740",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 30.748C9.5625 29.6435 10.4579 28.748 11.5625 28.748H55.375C56.4796 28.748 57.375 29.6435 57.375 30.748V48.3754C57.375 53.346 53.3456 57.3754 48.375 57.3754H18.5625C13.5919 57.3754 9.5625 53.346 9.5625 48.3754V30.748Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 30.748C9.5625 29.6435 10.4579 28.748 11.5625 28.748H55.375C56.4796 28.748 57.375 29.6435 57.375 30.748V48.3754C57.375 53.346 53.3456 57.3754 48.375 57.3754H18.5625C13.5919 57.3754 9.5625 53.346 9.5625 48.3754V30.748Z",
    stroke: "#005AA0",
    strokeWidth: 5.5,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-1_1920_2740)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4245 25.3797L31.7666 12.75H42.451L37.1088 25.3797H26.4245Z",
    stroke: "#005AA0",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1022 25.3797L26.4245 12.75C14.9185 12.75 11.2098 13.7215 11.21 25.3797H21.1022Z",
    stroke: "#005AA0",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4327 25.3797C57.4189 16.8304 51.1824 13.3977 48.3059 12.75L43.2828 25.3797H56.4327Z",
    stroke: "#005AA0",
    strokeWidth: 2.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovieIcon);
export default __webpack_public_path__ + "static/media/movie_icon.7203b77d6c85cf8ff9fd6e55975ce3e5.svg";
export { ForwardRef as ReactComponent };